/**
 * RadNeo™ Design System — Elevation / Shadow Tokens
 */

export const shadows = {
  none: 'none',
  low: '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)',
  medium: '0 4px 6px rgba(0, 0, 0, 0.06), 0 2px 4px rgba(0, 0, 0, 0.04)',
  high: '0 10px 15px rgba(0, 0, 0, 0.08), 0 4px 6px rgba(0, 0, 0, 0.04)',
  focus: '0 0 0 3px rgba(156, 225, 190, 0.35)',
  inset: 'inset 0 2px 4px rgba(0, 0, 0, 0.04)',
} as const;
